import { TinymceEditor } from '../editable-text/models/tinymce-editor/index';

export type EditorEvent = { editor: TinymceEditor };
export type EditorLifeCycleEvent = EditorEvent & { type: EditorLifeCycleEventType };
export enum EditorLifeCycleEventType {
  Add = 'add',
  Remove = 'remove',
}
